<template>
    <div :key="datefilterkey" class="datefilter-con">
        <!-- <vc-calendar is-expanded trim-weeks :max-date='new Date()' :attributes="attrs" @dayclick="onDayClick" color="green"/> -->
        <v-date-picker v-model="picker" :full-width="true" color="#328937" no-title :max="maxDate" :show-current="false"/>
        <div class="flex filter-buttons">
            <button @click="handleClearBtn" class="clear">Clear</button>
            <button @click="handleDoneBtn" class="done">Done</button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    ...mapActions(["queryStore", "GET_STARTDATE"]),
    name: "startdatefilter",
    data() {
        return {
            datefilterkey : false,
            storeStartdate : "",
            picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            maxDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        };
    },
    mounted(){
        this.getStoreDates()
    },

    methods: {
        handleClearBtn(){
            this.datefilterkey = !this.datefilterkey;    // change the key to reload the componet
            this.picker = "";
            this.$store.dispatch('queryStore/removestartdate');
            this.$emit('cleardaterange');
            
        },
        handleDoneBtn(){
            console.log("SELECTED DATE --> ", this.picker);
            this.$store.dispatch('queryStore/addstartdate', { stateid:this.picker}); 
            this.$emit('applydaterange')
        },
        
        // get dates from store 
        getStoreDates(){
            this.storeStartdate = this.$store.getters["queryStore/GET_STARTDATE"];
            this.picker = this.storeStartdate.stateid;
            console.log("STORE START DATE->", this.picker);
        },
    },
};
</script>

<style lang="scss">
.datefilter-con{
  padding: 20px;
  background-color: #FFFFFF;
}
.filter-buttons{
    width: 100%;
    column-gap: 20px;
    margin-top: 25px;

    button{
        padding: 15px 20px;
        border-radius: 5px;
        font-size: 0.8rem;
        font-weight: 500;
    }
}
.clear{
    background-color: rgba(57, 186, 123, 0.11);
    width: 50%;
    color: #328736;
}
.done{
    background-color: #36983B;
    width: 50%;    
    color: #fff;
}

/*
 * Styles copied from the Grid example to make grid rows & columns visible.
 */
.container {
  padding-right: 15px;
  padding-left: 15px;
}

.vc-header{
  padding: 10px 18px 20px 18px !important; 
}
.vc-weeks{
  padding: 15px !important;
}
.v-btn{
    font-weight: 400;
    font-size: 14px !important;
    color: #000 !important;
}

.v-date-picker-table .v-btn.v-btn--active{
    color: #FFF !important;
    font-weight: 500;
}
</style>
